<template>
  <div class="solfigrf-icmtournament-sctuctire solfigricmttr">
    <ExpandCard
      :opened="false"
      persistKey="solfigr_solfigricmttr"
      data-tst="solfigr_solfigricmttr"
      style="
        --clr-back-title: var(--clr-black-2);
        --clr-back-title-hover: var(--clr-black-2-3);
        --clr-back-title-active: var(--clr-black-2);
        --title-color: var(--clr-white-0);
        --content-padding: 0;
        --max-height: var(--vh-3);
        --radius: 4px;
        --radius-title: 4px 4px 0 0;
        --radius-content: 0 0 4px 4px;
        --open-overflow: unset;
        --overflow-content-open-y: unset;
        --overflow-content-open-x: unset;
      "
    >
      <template #title>
        <div
          class="f-center flex-1 mw-0"
          style="min-width: 0"
        >
          <div
            class="mdi mr-2"
            :class="
              icmTournament.errors.total_errors
                ? 'mdi-close-circle clr-error'
                : 'mdi-check-circle clr-primary'
            "
            :data-tst="`icm_tournament_structure${icmTournament.errors.total_errors ? '_error' : '_ok'}`"
          ></div>

          {{ $t(`solfigr.icm.tournament_structure`) }}
          <div class="spacer mx-2 clr-grey circle-bullet"></div>
          <div
            class="clr-grey truncate"
            :title="icmTournament.name || $t('solfigr.icm.tournament_name_unknown')"
          >
            {{ icmTournament.name || $t('solfigr.icm.tournament_name_unknown') }}
          </div>

          <div class="ml-auto clr-grey">
            <div
              class="gw_btn gw_btn_text clr-grey clr-hover_white text-medium"
              :class="{ 'opacity_5 no-events': icmTournament.errors.total_errors }"
              :data-tst="`solfigr_icm_save_as_preset${icmTournament.errors.total_errors ? '_disabled' : ''}`"
              @click.stop="openIcmStructuresSaveDialog"
            >
              <div class="mdi mdi-content-save mr-1 text-normal-large"></div>
              {{ $t(`solfigr.icm.save_as_preset`) }}
            </div>
          </div>
        </div>
      </template>

      <template #default="{ open }">
        <SolfigrIcmTournamentStructure
          style="border: solid 2px var(--clr-black-2); border-top: none; padding: 0.5rem"
          :loading
          :namespace
          :icmTournament
          :hasType
          :hasPayouts="open && hasPayouts"
          v-bind="$attrs"
        />
      </template>
    </ExpandCard>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import SolfigrIcmTournamentStructure from '@/components/ConfigureSolution/SolfigrIcmTournamentStructure.vue'

export default {
  name: 'SolfigrIcmTournamentStructureExpand',
  components: {
    ExpandCard,
    SolfigrIcmTournamentStructure,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    loading: Boolean,
    icmTournament: Object,
    hasType: { default: true, type: Boolean },
    hasPayouts: { default: true, type: Boolean },
  },
  methods: {
    openIcmStructuresSaveDialog() {
      if (this.icmTournament.errors.total_errors) return

      const dialog = `solfigr-icm-structures-save-dialog_namespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
}
</script>
